module.exports = __webpack_public_path__ + "static/media/close_icon.38c2d811.svg";